// Ayudas de las promos de venta, de referido y del bono de bienvenida; las comunes salen de Lifecycle.

export const SALE_PROMOTION_HELP = {
    filterRetailer: 'Muestra solo las promos de esa cadena.',
    airtime: 'Recargas de tiempo aire que recibe el cliente al comprar.',
    gift: 'Un accesorio que el cliente se lleva sin costo; puede ser de una lista o de una gama.',
    deviceDiscount: 'Descuento sobre el precio del equipo, en pesos o en porcentaje.',
    accessoryDiscount: 'Descuento sobre los accesorios de la venta, en pesos o en porcentaje.',
    walletBonus: 'Dinero que se deposita en el Wallet Fiado del cliente.',
    coupon: 'Un cupón de descuento para la siguiente compra del cliente.',
    oncePerCustomer: 'Si ya la usó, al cliente no le vuelve a salir.',
    stackable: 'Prendida se suma con otras promos en el mismo producto; apagada va sola.',
    paymentOptions: 'Con qué formas de pago aplica. Sin nada marcado aplica con cualquiera.',
    scopeType: 'Tipos de producto en los que aplica.',
    scopeTier: 'Gamas de producto en las que aplica.',
    scopeSku: 'Productos concretos en los que aplica.',
    scopeStore: 'Tiendas en las que aplica.',
    segments: 'Solo los clientes de los segmentos que marques. Con «Todos» aplica a todos.',
    surekeepCredit: 'Si la promo exige que el cliente tenga un crédito SK activo.',
    filterSegmentation: 'Muestra solo las promos con ese tipo de segmentación.',
    kpiActive: 'Promos que aplican hoy en las ventas nuevas.',
    kpiScheduled: 'Promos publicadas que todavía no empiezan.',
    kpiPaused: 'Promos detenidas a mano o por presupuesto.',
    kpiRedemptions: 'Ventas cobradas con alguna promo en los últimos 30 días.',
    kpiBudgetUsed: 'Lo gastado por las promos activas con tope, sobre la suma de sus topes.',
} as const;

export const REFERRAL_PROMOTION_HELP = {
    filterRetailer: 'Muestra solo las promos de esa cadena.',
    referrerReward: 'Qué gana el cliente que recomienda cuando su referido cumple el evento.',
    referredEnabled: 'Si el cliente recomendado también recibe un premio.',
    referredReward: 'Qué gana el cliente recomendado al cumplir el evento.',
    rewardAmount: 'Monto fijo del premio, en pesos.',
    rewardPercent: 'Porcentaje del premio sobre la compra o el crédito.',
    rewardCap: 'Lo máximo que puede valer el premio. Vacío no tiene tope.',
    couponType: 'Si el cupón descuenta un porcentaje o un monto fijo.',
    couponValue: 'Cuánto descuenta el cupón.',
    couponDays: 'Días que tiene el cliente para usar el cupón.',
    maxRewardsPerReferral: 'Cuántas veces se le paga a quien recomienda por cada referido.',
    maxReferredRewards: 'Cuántas veces se le paga al referido.',
    trigger: 'Lo que tiene que hacer el referido para que se pague el premio.',
    repeat: 'El número de la compra o de cupones seguidos que dispara el premio.',
    payWith: 'Con qué forma de pago tiene que comprar el referido para que cuente.',
    cashMethods: 'Medios de cobro de contado que cuentan. Sin elegir, cuenta cualquiera.',
    financiers: 'Financieras que cuentan. Sin elegir, cuenta cualquiera.',
    minAmount: 'Monto mínimo de la compra o del crédito del referido para que cuente.',
    windowDays: 'Días que tiene el referido, desde que lo recomendaron, para cumplir el evento.',
    maxRewardsPerReferrer: 'Cuántos premios puede ganar en total un mismo cliente que recomienda.',
    purchaseType:
        'Tipos de producto de la compra del referido que cuentan. Sin elegir, cuenta cualquiera.',
    purchaseTier:
        'Gamas de producto de la compra del referido que cuentan. Sin elegir, cuenta cualquiera.',
    stores: 'Tiendas donde cuenta el evento del referido. Sin elegir, cuenta en todas.',
} as const;

/** Ayudas de «Códigos y cupones»: lista, secciones del detalle y campos del alta. */
export const DISCOUNT_CODE_HELP = {
    view: 'Los códigos los creas tú y los usa cualquier cliente; los cupones los emite una venta para su dueño.',
    search: 'Busca por el texto del código entre lo cargado, sin importar mayúsculas.',
    description: 'El texto que el cliente da en caja y de dónde salió.',
    levers: 'Cuánto baja el precio del equipo: un monto en pesos o un porcentaje.',
    scope: 'En qué equipos, tiendas y formas de pago vale. Sin nada elegido vale en todo.',
    rules: 'Cuántas veces se puede usar y si se anuncia en tienda.',
    coupon: 'La venta que emitió el cupón, su tienda y el cliente dueño, el único que lo puede usar.',
    codeText: 'Lo que el cliente da en caja; se guarda en mayúsculas.',
    discountType: 'Si descuenta un monto fijo en pesos o un porcentaje del precio.',
    discountValue: 'Cuánto descuenta.',
    maxUses:
        'Cuántas ventas lo pueden usar en total. Vacío no tiene tope; al llegar al tope se agota.',
    paymentOptions: 'Con qué formas de pago vale. Sin nada marcado vale con cualquiera.',
    announceInStore: 'Si el vendedor lo ve anunciado en tienda para ofrecerlo.',
    couponScope: 'Dónde vale el cupón, según la promo que lo emitió.',
    uses: 'Cuántas ventas ya lo usaron, contra su tope.',
    redeemedIn: 'La venta donde se canjeó, o cuántas ventas lo usaron.',
    issuingSale: 'La venta que emitió el cupón.',
    issuingStore: 'La tienda donde se hizo esa venta.',
    owner: 'El cliente dueño del cupón, el único que lo puede usar.',
} as const;

/** La cadena de un código nuevo: uno por cadena para no repartir su tope de usos entre varias. */
export const DISCOUNT_CODE_RETAILER_HELP =
    'Elige primero la cadena: el código vale solo ahí, con sus tiendas y equipos. Su tope de usos es de este código; para otra cadena crea otro.';

/** Textos de la promo creada en varias cadenas a la vez. */
export const MULTI_RETAILER_COPY = {
    stores: 'Con varias cadenas, cada copia aplica en todas sus tiendas.',
    catalog: 'Con varias cadenas, cada copia aplica en todo su catálogo.',
    prefill:
        'El SKU viene de Inventario: elige la cadena de ese SKU. Si eliges otra o varias, el SKU se suelta.',
    giftList:
        'Con varias cadenas el regalo va «De una gama»: la lista de accesorios es de una sola cadena.',
    locked: 'Ya se crearon copias en algunas cadenas. Para que todas salgan iguales la promo no se edita: guarda para reintentar solo las que faltan, o descarta.',
} as const;

export const WELCOME_BONUS_HELP = {
    amount: 'Lo que se deposita en la cuenta PagoConFiado del cliente al abrirla.',
} as const;
